module.exports = __webpack_public_path__ + "static/media/pinch03.ee137819.webp";